module.exports = __webpack_public_path__ + "img/Vive-Real-Estate-Team-1024x665.865fe6f9.jpeg";